export default "__VITE_ASSET__037e3a6c__"